import { type ClosedDeal } from './content.ts';

const DealCard = ({ deal }: { deal: ClosedDeal }): JSX.Element => {
    const rows: Array<[string, string]> = [
        ['Purchase Price:', deal.purchasePrice],
        ['Rehab Cost:', deal.rehabCost],
        ['ARV:', deal.arv]
    ];

    return (
        <div className="w-full mt-8 xl:mt-0">
            <img
                className="w-full"
                src={deal.image.src}
                alt={deal.image.alt}
                width={deal.image.width}
                height={deal.image.height}
            />
            <div className="px-8 py-8 bg-gray-100">
                {rows.map(([label, value], index) => (
                    <div key={label} className={`flex justify-between${index > 0 ? ' mt-3' : ''}`}>
                        <p className="font-bold text-lg">{label}</p>
                        <p className="text-lg">{value}</p>
                    </div>
                ))}
                <hr className="mt-5 mb-5"/>
                <p className="text-blue-900 font-bold text-2xl">{deal.equityCreated}</p>
                <p className="font-bold text-lg">Equity Created</p>
            </div>
        </div>
    );
};

export default DealCard;
